var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIndicaWhite = function SvgIndicaWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#indica_white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 1.5,
    d: "M18.712 42.617a16 16 0 0 1-2.535-.204c-.518-.08-3.085-.536-3.356-1.338s1.85-3.01 4.176-4.473c-4.88-2.368-9-6.94-9.438-8.229a.73.73 0 0 1 0-.574c.475-.925 5.12-.573 8.772.352-2.005-4.367-3.596-11.165-2.369-11.807.956-.617 5.478 2.702 8.636 6.25.562-5.528 2.838-13.344 4.325-13.344 1.486 0 3.763 7.816 4.318 13.318 3.17-3.547 7.686-6.847 8.673-6.23 1.234.617-.388 7.402-2.393 11.788 3.645-.925 8.297-1.277 8.772-.351a.75.75 0 0 1 0 .574c-.444 1.314-4.565 5.885-9.445 8.253 2.32 1.462 4.43 3.67 4.183 4.473s-2.838 1.233-3.356 1.338a14.1 14.1 0 0 1-5.904-.24 7.86 7.86 0 0 1-4.842-3.67 7.88 7.88 0 0 1-4.849 3.67c-1.096.305-2.23.455-3.368.444Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "indica_white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h52v52H.5z"
  })))));
};
export default SvgIndicaWhite;